export default [
  {
    path: "/resources/code-of-conduct",
    name: "CodeOfConduct",
    alias: ["/about/code-of-conduct", "/code-of-conduct"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/code-of-conduct";
    }
  },
  {
    path: "/resources/privacy-policy",
    name: "PrivacyPolicy",
    alias: ["/privacy-policy"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/privacy-policy";
    }
  },
  {
    path: "/resources/terms-of-service",
    name: "TermsOfService",
    alias: ["/tos", "/resources/tos"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/terms-of-service";
    }
  },
  {
    path: "/resources/legal",
    name: "Legal",
    alias: ["/legal"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/legal";
    }
  }
];
